/**
 * 平台超管本地会话（add-platform-admin-web）。
 *
 * 与员工会话（utils/auth-session.ts，key `cms.auth.token`）完全独立：
 * token 持久化到 localStorage key `platform-token`，两套身份互不识别，
 * 由路由守卫（员工 token ↔ 超管 token）分流拦截。
 */
const TOKEN_KEY = 'platform-token'
let memoryToken: string | null = null

export function getPlatformToken(): string | null {
  try {
    const persisted = window.localStorage.getItem(TOKEN_KEY)
    memoryToken = persisted
    return persisted
  } catch {
    return memoryToken
  }
}

export function setPlatformToken(token: string): void {
  memoryToken = token
  try {
    window.localStorage.setItem(TOKEN_KEY, token)
  } catch {
    // localStorage 不可用（隐私模式等）时忽略，本次会话仍可用
  }
}

export function clearPlatformToken(): void {
  memoryToken = null
  try {
    window.localStorage.removeItem(TOKEN_KEY)
  } catch {
    // ignore
  }
}

export function hasPlatformSession(): boolean {
  const token = getPlatformToken()
  return typeof token === 'string' && token.length > 0
}
